import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef, useMemo } from 'react';
import clsx from 'clsx';
import MuiListItem from '@material-ui/core/ListItem';
import { combineClasses, combineProps, styled, useDeprecatedCheck, useThemeProps, } from '../../../foundation';
import { withTooltip } from '../../Tooltip';
import { ListItemStyle } from './styles';
import { RcListItemClasses, RcListItemMultilineClassName, RcListItemRippleClasses, } from './utils';
var _RcListItem = forwardRef(function (props, ref) {
    if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useDeprecatedCheck(RcListItem, props, [
            {
                prop: 'baseColor',
                time: '2021-9',
                comment: '@deprecated should use color directly',
            },
            {
                prop: 'maxWidth',
                time: '2021-4',
                comment: 'recommend using classes to define',
            },
        ]);
    }
    var classesProp = props.classes, color = props.color, TouchRipplePropsProp = props.TouchRippleProps, children = props.children, className = props.className, singleLine = props.singleLine, button = props.button, size = props.size, canHover = props.canHover, isInline = props.isInline, baseColor = props.baseColor, title = props.title, highlighted = props.highlighted, maxWidth = props.maxWidth, focused = props.focused, focusVariant = props.focusVariant, rest = __rest(props, ["classes", "color", "TouchRippleProps", "children", "className", "singleLine", "button", "size", "canHover", "isInline", "baseColor", "title", "highlighted", "maxWidth", "focused", "focusVariant"]);
    var classes = useMemo(function () { return combineClasses(RcListItemClasses, classesProp); }, [classesProp]);
    var ListItemClassName = useMemo(function () {
        var _a;
        return clsx(className, (_a = {},
            _a[RcListItemMultilineClassName] = !singleLine,
            _a[classes.focusVisible] = focused,
            _a));
    }, [className, singleLine, classes, focused]);
    // * when not button can't have TouchRippleProps
    var additionProps = useMemo(function () {
        return button
            ? {
                TouchRippleProps: combineProps({ classes: RcListItemRippleClasses }, TouchRipplePropsProp),
            }
            : {};
    }, [TouchRipplePropsProp, button]);
    return (React.createElement(MuiListItem, __assign({}, rest, additionProps, { ref: ref, title: typeof title === 'string' ? title : undefined, classes: classes, className: ListItemClassName, button: button }), children));
});
var RcListItem = styled(withTooltip(_RcListItem)).attrs(function (inProps) {
    var _a = useThemeProps({ props: inProps, name: 'RcListItem' }), 
    // @ts-ignore
    theme = _a.theme, 
    // Omit className, prevent duplicate className
    className = _a.className, _b = _a.singleLine, singleLine = _b === void 0 ? false : _b, _c = _a.button, button = _c === void 0 ? true : _c, _d = _a.canHover, canHover = _d === void 0 ? true : _d, _e = _a.size, size = _e === void 0 ? 'medium' : _e, _f = _a.focusVariant, focusVariant = _f === void 0 ? 'highlight' : _f, rest = __rest(_a, ["theme", "className", "singleLine", "button", "canHover", "size", "focusVariant"]);
    return __assign({ singleLine: singleLine,
        button: button,
        canHover: canHover,
        size: size,
        focusVariant: focusVariant }, rest);
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), ListItemStyle);
RcListItem.displayName = 'RcListItem';
export { RcListItem };
var templateObject_1;
